// extracted by mini-css-extract-plugin
export default {"wrapper":"AdminDocuments_wrapper__enYPA","container":"AdminDocuments_container__0piir"};